import {option, Option} from "ts-option";
import {JobAgentChangeNotificationDataApiDto} from "../../../../api/model/rest";
import AuthenticatedEntity from "../../../user/AuthenticatedEntity";

/**
 * Agent change notification class data.
 */
export default class JobAgentChangeNotificationData {
	/**
	 *
	 * @param {string} jobId
	 * @param {string} entity Entity from who assignee change originates.
	 * @param {Option<string>} previousAgentId id of the previous agent.
	 * @param {Option<string>} currentAgentId id of the current agent.
	 * @param {string} referenceNumber
	 */
	constructor(readonly jobId: string,
		readonly entity: AuthenticatedEntity,
		readonly previousAgentId: Option<string>,
		readonly currentAgentId: Option<string>,
		readonly referenceNumber: string) {}

	static fromJson(json: JobAgentChangeNotificationDataApiDto): JobAgentChangeNotificationData {
		const creator = AuthenticatedEntity.fromJson(json.entity);
		return new JobAgentChangeNotificationData(json.jobId, creator, option(json.previousAgentId),
			option(json.currentAgentId), json.referenceNumber);
	}

	getJobReferenceNumber() {
		return this.referenceNumber
	}
}
